/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { addLocale } from "primereact/api";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

import AutocompleteFloatLabel from "../../../components/AutocompleteFloatLabel";
import Dialog from "../../../components/Dialog";
import { ptBrDatepickerTranslations } from "../../../i18n/locales/pt-br";
import Professor from "../../../model/dto/Professor";
import {
    getOptionsTipoCartaoEnum,
    TipoCartaoEnum,
} from "../../../model/Enums/TipoCartaoEnum";
import IModalProps from "../../../model/ModalProps";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import FormAnticipation from "./FormAnticipation";
import FormIntraday from "./FormIntraday";
import FormReplacement from "./FormReplacement";
import FormReposicao from "./FormReposicao";
import FormAvulso from "./FormAvulso";

// IMPORT DO FORM DE HORA EXTRA COMENTADO INTENCIONALMENTE
// import FormHoraExtraTela from "./FormHoraExtraTela";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton, StyledModalText } =
    DialogStyles;

interface IVigencia {
    planoAtividadeId: number;
}

interface IModalCreateCardProps extends IModalProps {
    matriculaAdp: string;
    docente: Professor;
    refreshScheduleCard?: (cartaoAgendaId: number[]) => void;
    vigencia: IVigencia[];
    dataInicioSemana: string;
    dataFimSemana: string;
}

function ModalCreateCard(props: IModalCreateCardProps) {
    const [showDialog, setShowDialog] = useState(props.visibility ?? true);
    const [typeCardOptions, setTypeCardOptions] = useState<any[]>([]);
    const [typeCard, setTypeCard] = useState<any[]>([]);

    const { matriculaAdp, docente, vigencia, dataInicioSemana, dataFimSemana } =
        props;

    /**
     * Retorna somente os tipos de cartão permitidos,
     * filtrando por algumas condições, como se vigência é vazia
     * e se docente.gerarAgenda for true.
     */
    const handleFormatCardOptions = () => {
        return getOptionsTipoCartaoEnum().filter((item) =>
            [
                String(TipoCartaoEnum.Antecipacao),
                String(TipoCartaoEnum.Intrajornada),
                String(TipoCartaoEnum.Substituicao),
                String(TipoCartaoEnum.Reposicao),
                // HORA EXTRA COMENTADA INTENCIONALMENTE
                // docente.gerarAgenda && String(TipoCartaoEnum.HoraExtraTela),

                // Atividades Avulsas exibidas somente se não há vigência
                // e se docente.gerarAgenda é true
                vigencia?.length === 0 &&
                    docente.gerarAgenda &&
                    String(TipoCartaoEnum.AtividadesAvulsas),
            ].includes(item.value)
        );
    };

    const handleSetTypeCardOptions = () => {
        setTypeCardOptions(handleFormatCardOptions());
    };

    useEffect(() => {
        handleSetTypeCardOptions();
    }, []);

    const controlShowDialog = (show: any) => {
        if (show) {
            setShowDialog(true);
        }
        setShowDialog(false);
    };

    /**
     * Mapeia cada enum de cartão a um formulário específico.
     * A parte de Hora Extra está comentada para não aparecer no momento.
     */
    const typeCardComponents: Record<number, JSX.Element> = {
        [TipoCartaoEnum.Intrajornada]: (
            <FormIntraday
                onSubmit={(value) => {
                    if (props.onClose) {
                        props.onClose({
                            success: true,
                            data: {
                                typeCard: TipoCartaoEnum.Intrajornada,
                                dataCard: value,
                            },
                        });
                    }
                }}
            />
        ),
        [TipoCartaoEnum.Antecipacao]: (
            <FormAnticipation
                matriculaAdp={matriculaAdp}
                docente={docente}
                onCreate={() => {
                    if (props.onClose) {
                        props.onClose({
                            success: true,
                            data: { typeCard: TipoCartaoEnum.Antecipacao },
                        });
                    }
                }}
            />
        ),
        [TipoCartaoEnum.Substituicao]: (
            <FormReplacement
                onCreate={() => {
                    if (props.onClose) {
                        props.onClose({
                            success: true,
                            data: { typeCard: TipoCartaoEnum.Substituicao },
                        });
                    }
                }}
                refreshScheduleCard={props.refreshScheduleCard!}
                matriculaAgenda={matriculaAdp}
                docente={docente}
            />
        ),
        [TipoCartaoEnum.Reposicao]: (
            <FormReposicao
                onCreate={() => {
                    if (props.onClose) {
                        props.onClose({
                            success: true,
                            data: { typeCard: TipoCartaoEnum.Reposicao },
                        });
                    }
                }}
                teacher={docente}
                refreshScheduleCard={props.refreshScheduleCard!}
            />
        ),
        [TipoCartaoEnum.AtividadesAvulsas]: (
            <FormAvulso
                onCreate={() => {
                    if (props.onClose) {
                        props.onClose({
                            success: true,
                            data: {
                                typeCard: TipoCartaoEnum.AtividadesAvulsas,
                            },
                        });
                    }
                }}
                docente={docente}
                matriculaAdp={matriculaAdp}
                dataInicioSemana={dataInicioSemana}
                dataFimSemana={dataFimSemana}
                typeCard={TipoCartaoEnum.AtividadesAvulsas}
            />
        ),
        // HORA EXTRA COMENTADA INTENCIONALMENTE
        // [TipoCartaoEnum.HoraExtraTela]: (
        //   <FormHoraExtraTela
        //     onCreate={() => {
        //       if (props.open) {
        //         setShowDialog(false);
        //       }
        //       if (props.onClose) {
        //         setShowDialog(props.visibility ?? true);
        //         props.onClose({
        //           success: true,
        //           data: { typeCard: TipoCartaoEnum.HoraExtraTela },
        //         });
        //       }
        //     }}
        //     docente={docente}
        //     matriculaAdp={matriculaAdp}
        //     dataInicioSemana={dataInicioSemana}
        //     dataFimSemana={dataFimSemana}
        //     refreshScheduleCard={props.refreshScheduleCard!}
        //     controlShowDialog={controlShowDialog}
        //   />
        // ),
    };

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <Dialog
            openModal={props.open}
            onHide={props.onClose}
            className={`${dialogClass} modal-create-card`}
            style={{ width: "100%" }}
        >
            <StyledModalTitle className="mb-3">Criar cartão</StyledModalTitle>
            <StyledModalText className="mb-4">
                Você pode criar um novo cartão e arrastá-lo para o período
                desejado.
            </StyledModalText>
            <Row>
                <Col>
                    <AutocompleteFloatLabel
                        label="Tipo de cartão"
                        options={typeCardOptions}
                        selected={typeCard}
                        onChange={setTypeCard}
                        className="modal-create-card-autocomplete"
                    />
                </Col>
            </Row>

            {typeCardComponents[typeCard.at(0)?.value]}

            <StyledContainerButton>
                <DefaultButtonLink onClick={props.onClose}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
        </Dialog>
    );
}

export default ModalCreateCard;
